import { IRectangle, List } from '@fluentui/react';
import { PopularSearchModel } from '../../websites/models/PopularSearchModel';

type PopularSearchProps = {
    list: PopularSearchModel[];
    onSelect: (search: PopularSearchModel) => void;
}

export default function PopularSearchView({ list, onSelect }: PopularSearchProps) {
    var columnCount: number = 2;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            let count = 2;

            const width = surfaceRect?.width ?? 0;
            count = Math.trunc(width / 220);

            if (count < 2) count = 2;

            columnCount = count;
        }

        return list.length;
    }

    const onRenderCell = (search?: PopularSearchModel, index?: number, isScrolling?: boolean) => {
        if (!search) {
            return <div></div>;
        }

        const width = (100 / columnCount) + '%';

        return <div key={search.id} className="list-grid-tile p-10 cursor" style={{ width: width }}>
            <div onClick={() => onSelect(search)} className={"box pv-10 center"}>
                {search.text}
            </div>
        </div>;
    }

    return <div>
        <List
            items={list}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}